import { app } from '../app';
import colors from './colors';

export default function createPoints(data) {
	// Stash a copy of the site data
	app.groups = data.sites;

  // Create initial set of points
	let points = [];
	let group = -1;
	for (let key in data.sites) {
		group += 1;

    // To keep the filesize down,
    // websites are grouped if they have the same domain/lang/topic.
    // Data is stored in the key, count in the value.
    // Here we split everything out again.
    let [domain, languages, topics] = key.split('|');
    languages = languages.split(':');
    topics = topics.split(':');

    for (let i = 0; i < data.sites[key]; i++) {
      points.push({
        // Set each point defaults
				tx: window.innerWidth / 2,
				ty: window.innerHeight / 2,
				colorEnd: colors.dark.vector,
				group,
				domain,
				languages,
				topics,
			});
    }
  }

	// Right now 'online' and 'new' data is not on a site-by-site basis,
	// just as a lump count. Adding it to points but it shouldn't be used
	// to map relationships between site domain/lang/topic and online/new
	// for (let i = 0, newMax = data.status.newToday; i < data.status.onlineToday; i++) {
	// 	let topic = i < newMax ? ['online', 'new'] : ['online'];
	// 	points[i].topics = points[i].topics.concat(topic);
	// }

  // Shuffle the data (makes the animation look cooler)
	app.points = points.sort(() => Math.random() > 0.5 ? -1 : 1);

  // Set stuff regl needs
  app.numPoints = points.length;
  app.delayByIndex = 500 / points.length;
  app.maxDuration = app.duration + app.delayByIndex * points.length;
}



// WEBPACK FOOTER //
// ./src/helpers/createPoints.js